import API, { ensurePrefixed } from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived, hasFiles } from 'utils/formatValues';
import { padronesEnum } from 'views/Tramites/GPM/enums';

export const baseURI = '/recaudacion/infracciones/';

/**
 * GET Infracciones
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getInfracciones = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    const output = { ...response.data, results: formatReceived(response.data.results) };
    return output;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Infraccion
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getInfraccion = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Infraccion
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postInfracciones = async (values, accion = 'INFRACCION') => {
  try {
    const accionInf = ensurePrefixed('CREAR_', accion);
    const formattedValues = getFormattedValues(values, {}, ['momento_de_infraccion']);
    const response = await API.post(baseURI, formattedValues, {
      accionInf,
      idPadron: padronesEnum.INFRACCIONES,
      clave: formattedValues.clave,
    });
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Infraccion
 * @param {number} id
 * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const patchInfraccion = async (id, _values, accion = 'INFRACCION') => {
  try {
    const accionInf = ensurePrefixed('ACTUALIZAR_', accion);
    const files = ['archivo_cancelacion'];
    const config = hasFiles(_values, files) ? { headers: { 'Content-Type': 'multipart/form-data' } } : {};
    const response = await API.patch(
      `${baseURI}${id}`,
      getFormattedValues(_values, {
        files,
        formData: config.headers,
        clean: false,
      }, ['momento_de_infraccion', 'hora_cierre_licencia', 'fecha_de_cancelacion']),
      {
        ...config,
        accionInf,
        idPadron: padronesEnum.INFRACCIONES,
        clave: _values.clave,
      },
    );
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE Infraccion
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteInfraccion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Zonas Exclusivas para la caja
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */

export const getInfraccionesCaja = async (params = null) => {
  try {
    const response = await API.get('/recaudacion/infracciones-caja/', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
